import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { Address, Res } from '../models';
import { ApiBasicService } from './api-basic.service';
import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root'
})
export class ApiOrganizationsService {

  currentOrganization: any;
  currentOrganizationSubject = new Subject<any>();

  constructor(
    private apiBasic: ApiBasicService,
    private api: ApiService
  ) { }


  /**
   * 
   * @param value string
   */
  setDataCurrentOrganization(value: string): void {

    this.currentOrganization = value;
    this.currentOrganizationSubject.next(value);
  }


  /**
   * 
   * @returns Observable<any>
   */
  listenerCurrentOrganization(): Observable<any> {

    return this.currentOrganizationSubject.asObservable();
  }


  /**
   * 
   * @param params any
   * @returns Observable<Res>
   */
  getList(params: any): Observable<Res> {

    return this.apiBasic.getList(params, 'organization');
  }

  /**
   * 
   * @param params any
   * @returns Observable<Res>
   */
  getReferences(params: any, moduleName): Observable<Res> {

    return this.apiBasic.getReferences(params, moduleName);
  }


  /**
   * 
   * @param id string
   * @returns Observable<Res>
   */
  info(id: string): Observable<Res> {

    return this.apiBasic.getInfo('organization', id);
  }

  /**
   * 
   * @param id 
   * @returns 
   */
  employeeInfo(id: string): Observable<Res> {
    return this.apiBasic.getInfo('employee', id);
  }


  /**
   * 
   * @param params any
   * @returns Observable<Res>
   */
  create(params: any): Observable<Res> {

    return this.apiBasic.create('organization', params);
  }

  /**
   * 
   * @param id string
   * @returns Observable<Res>
   */
  edit(id: string): Observable<Res> {

    return this.apiBasic.edit('organization', id);
  }

  /**
  * 
  * @param params any
  * @returns Observable<Res>
  */
  update(params: any): Observable<Res> {

    return this.apiBasic.update('organization', params);
  }

  /**
  * 
  */
  delete(params: any): Observable<Res> {

    return this.apiBasic.delete('organization', params);
  }

  /**
  * 
  */
  onSearch(params: any): Observable<Res> {

    return this.apiBasic.onSearch('product', params);
  }


  /**
   * 
   * @param params any
   * @returns Observable<Res>
   */
  changeDefaultOrganization(params: any): Observable<Res> {

    return this.apiBasic.update('default_organization', params);
  }


  /**
   * 
   * @param address Address
   * @returns string
   */
  addressObjToString(address: Address): string {

    let obj: Address = { ...address };

    delete obj.id;
    delete obj.address_type;

    // let arr: string[] = Object.values(obj).filter(val => (val && val != null && val != undefined));
    // let str: string   = arr.join(', ');

    let str: string = '';

    str += address.index ? address.index : '';
    str += address.locality ? ', ' + address.locality : '';
    str += address.street ? ', ' + address.street : '';
    str += address.home ? ', ' + address.home : '';

    return str;
  }


  /**
   * Сортировка адресов для того что бы Юр. адрес был всегда первым
   * @param addresses Address[]
   * @returns Address[]
   */
  sortAddress(addresses: Address[]): Address[] {

    let arr: Address[] = [];

    for (let address of addresses) {

      if (address.address_type == 'legal') {

        arr.unshift(address);
      }

      if (address.address_type == 'actual') {

        arr.push(address);
      }
    }

    return arr;
  }

  /**
  * 
  * @param objName string
  * @param params any
  * @returns Observable<Res>
  */
  getBarcodes(methodname, params): Observable<Res> {

    return this.api.upload(methodname, params);
    // return this.api.post(methodname, params, 'private', 'files');
  }
}
